import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from 'redux/actions/settingActions';
import { Translate } from 'react-redux-i18n';

const Taxes = (props) => {
  const [values, setValues] = useState({
    option_tax: (props.item && props.item.option_tax) || 0,
    stock_tax: (props.item && props.item.stock_tax) || 0,
    tax_id: props.item && props.item.id,
    id: props.user_id,
  });

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleSave = (e) => {
    e.preventDefault();
    props.updateItem({
      ...values,
    }, props.token);
  };

  useEffect(() => {
    setValues({
      option_tax: (props.item && props.item.option_tax) || 0,
      stock_tax: (props.item && props.item.stock_tax) || 0,
      tax_id: props.item && props.item.id,
      id: props.user_id,
    });
  }, [props.item, props.user_id]);

  return (
    <div className="settings-panel">
      <h3 className="settings-panel-title">
        <Translate value="taxes" />
      </h3>
      <p className="settings-panel-subtitle">
        <Translate value="manage_taxes" />
      </p>
      <form onSubmit={handleSave}>
        <div className="settings-field-row">
          <div className="settings-field">
            <label htmlFor="option_tax">
              <Translate value="close_option" />
            </label>
            <input
              id="option_tax"
              name="option_tax"
              type="number"
              min="0.01"
              step="0.01"
              required
              value={values.option_tax}
              onChange={handleChange}
            />
          </div>
          <div className="settings-field">
            <label htmlFor="stock_tax">
              <Translate value="close_stock" />
            </label>
            <input
              id="stock_tax"
              name="stock_tax"
              type="number"
              min="0.01"
              step="0.01"
              required
              value={values.stock_tax}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="settings-panel-actions">
          <button type="submit" className="btn btn-primary">
            <Translate value="save" />
          </button>
        </div>
      </form>
    </div>
  );
};

Taxes.propTypes = {
  className: PropTypes.string,
};

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.token,
    item: reducer.setting.item,
    success: reducer.setting.success,
  };
}

const mapDispatchToProps = (dispatch) => ({
  updateItem: (params, token) =>
    dispatch(actions.updateItem({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Taxes);
